export default __webpack_public_path__ + "static/media/cdr-logo-white.db7655a9.svg";